import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withTranslations from '../../utils/HighOrderComponent';
import { rowsPerPageOptions, userRoles } from '../../constants/globals.js';
import { TablePagination } from '@material-ui/core';
import { changePaginationTextToSerbian, checkForUserRole } from '../../utils';
import {
  findAllSignetPageable,
  findAllSignetFilterPageable,
  findAllSignetsByClient,
} from '../../actions/signet';
import SignetTable from '../Signet/SignetTable';
import { clearContentRequestForSignetStatus } from '../../actions/requestForSignetStatusAttachment';

class SignetList extends Component {
  componentDidMount() {
    this.handleFindAllTrigger(0, this.props.pageSize);
    this.props.clearContentRequestForSignetStatus();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetData) {
      const postData = {
        tableName: 'signet',
        filterCriteria: [{ returnAllSignal: true }],
      };
      this.props.findAllSignetFilterPageable(0, nextProps.pageSize, postData);
      nextProps.setResetData(false);
    }
  }

  handleFindAllTrigger = (pageNumber, pageSize) => {
    const { loggedUser } = this.props || {},
      { roles, id } = loggedUser || {};
    if (checkForUserRole(roles, userRoles.AUTHORIZED_PERSON.value)) {
      this.props.findAllSignetsByClient(id, pageNumber, pageSize);
    } else this.props.findAllSignetPageable(pageNumber, pageSize);
  };

  handlePageChange = (event, value) => {
    const { setActivePage, postData, pageSize, findAllSignetFilterPageable } =
      this.props || {};
    setActivePage(value);
    postData
      ? findAllSignetFilterPageable(0, pageSize, postData)
      : this.handleFindAllTrigger(value, pageSize);
  };

  handleChangeRowsPerPage = (event, value) => {
    const {
      setPageSize,
      setActivePage,
      postData,
      findAllSignetFilterPageable,
    } = this.props || {};
    setPageSize(event.target.value);
    setActivePage(0);
    postData
      ? findAllSignetFilterPageable(0, event.target.value, postData)
      : this.handleFindAllTrigger(0, event.target.value);
  };

  render() {
    const { t, signet, loggedUser, activePage, pageSize } = this.props || {},
      { roles } = loggedUser || {},
      { signetList, totalElements } = signet || {};

    const isUserProcessor = checkForUserRole(roles, userRoles.MDULS.value);
    const isUserAuthorizedPerson = checkForUserRole(
      roles,
      userRoles.AUTHORIZED_PERSON.value
    );

    return (
      <Fragment>
        <SignetTable
          signetList={signetList}
          isUserProcessor={isUserProcessor}
          isUserAuthorizedPerson={isUserAuthorizedPerson}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <TablePagination
            component="div"
            count={Number(totalElements)}
            page={activePage}
            onPageChange={this.handlePageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPage={pageSize}
            labelRowsPerPage={t.rowPerPage}
            labelDisplayedRows={(obj) =>
              changePaginationTextToSerbian(obj, t.of)
            }
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  signet: state.signet,
  loggedUser: state.loggedUser?.loggedUser,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllSignetPageable: (pageNumber, pageSize) => {
      dispatch(findAllSignetPageable(pageNumber, pageSize));
    },
    findAllSignetFilterPageable: (
      pageNumber,
      pageSize,
      postData,
      successCallback
    ) => {
      dispatch(
        findAllSignetFilterPageable(
          pageNumber,
          pageSize,
          postData,
          successCallback
        )
      );
    },
    findAllSignetsByClient: (userId, pageNumber, pageSize) => {
      dispatch(findAllSignetsByClient(userId, pageNumber, pageSize));
    },
    clearContentRequestForSignetStatus: () => {
      dispatch(clearContentRequestForSignetStatus());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslations(SignetList, 'SignetList'));
